import React, { Component } from 'react';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

export class RenderRedunicrePaymentForm extends Component {

    render() {
        const { paymentGateway, handleData, idx } = this.props;

        return (
            <div>
                <FormGroup row>
                    <Label sm={2}>
                        <FormattedMessage id="PaymentGateway.ApiUser" />
                    </Label>
                    <Col sm={10}>
                        <Input type="text" maxLength="50" name="userId" id="userId" value={paymentGateway.userId ? paymentGateway.userId : ''} onChange={evt => handleData(evt, idx)} required />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={2}>
                        <FormattedMessage id="PaymentGateway.Password" />
                    </Label>
                    <Col sm={10}>
                        <Input type="text" maxLength="700" name="accessToken" id="accessToken" value={paymentGateway.accessToken ? paymentGateway.accessToken : ''} onChange={evt => handleData(evt, idx)} required />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={2}>
                        <FormattedMessage id="PaymentGateway.MbValidityHours" />
                    </Label>
                    <Col sm={10}>
                        <Input type="number" max="240" name="mbValidatyDays" id="mbValidatyDays" value={paymentGateway.mbValidatyDays ? paymentGateway.mbValidatyDays : ''} onChange={evt => handleData(evt, idx)} required={paymentGateway.validPaymentModes.some(md => md === 'SibsMultibanco')} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={2}>
                        <FormattedMessage id="PaymentGateway.DaysBeforeCheckIn" />
                    </Label>
                    <Col sm={10}>
                        <Input disabled={paymentGateway && paymentGateway.validPaymentModes && !paymentGateway.validPaymentModes.some(md => md === 'SibsMultibanco')} type="number" max="240" min="0" name="daysBeforeCheckIn" id="daysBeforeCheckIn" value={paymentGateway.daysBeforeCheckIn ? paymentGateway.daysBeforeCheckIn : ''} onChange={evt => handleData(evt, idx)} required={paymentGateway.validPaymentModes.some(md => md === 'SibsMultibanco')} />
                    </Col>
                </FormGroup>
            </div>
        );
    }
}